import type { FaireProductEntity } from "../../entity_types/product";

export const p_kyp5w3r9bf: FaireProductEntity = {
  token: "p_kyp5w3r9bf",
  type: "product",
  name: "Leather Wood Pendant Keychain Gift For Dad Mom Friends",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/9bd69fbde69a3a75a28914b48b40bf9f110cd2304acb03ebf431963bcf8e2d42.jpeg",
  priceDollars: 2.44,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/41376ee28ba29996d1e23aab70d18ee7234d145a43c7e191ab895e5689644b13.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
